import { render } from "./WinPrices.vue?vue&type=template&id=32c8b70e"
import script from "./WinPrices.vue?vue&type=script&lang=js"
export * from "./WinPrices.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__